import React from "react"
import { MyMazdaWrapper } from "containers"
import { MyMazdaDetails } from "AtomicContainers"

const MyMazdaCreateAccount = props => (
  <MyMazdaWrapper breadcrumb={["MyMazda", "Create account"]}>
    <MyMazdaDetails {...props} />
  </MyMazdaWrapper>
)

export default MyMazdaCreateAccount



// WEBPACK FOOTER //
// ./src/blocks/mymazda/create-account/index.jsx